import { __decorate } from "tslib";
import { Plans } from '@/helpers/entities/enums/v2/FilterSelection';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import { Mixins, Component } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import ReferredMerchantsExport from '@/components/v2/network_distributor/ReferredMerchantsExport';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import { Getter } from 'vuex-class';
import moment from 'moment';
let ReferredMerchantExport = class ReferredMerchantExport extends Mixins(AlertMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.plan = 'free_starter';
    }
    get planOptions() {
        return [
            selectOptionBuilder(Plans.freeStarter),
            selectOptionBuilder(Plans.proMsme),
            selectOptionBuilder(Plans.proStarter),
            selectOptionBuilder(Plans.proBronze),
            selectOptionBuilder(Plans.proSilver),
            selectOptionBuilder(Plans.proGold),
            selectOptionBuilder(Plans.proPlatinum),
            selectOptionBuilder(Plans.proDiamond),
            selectOptionBuilder(Plans.proMythical),
            selectOptionBuilder(Plans.proPremium),
        ];
    }
    get labels() {
        const labels = {
            merchantName: 'Merchant Name',
            merchantId: 'Merchant ID',
            planType: 'Plan Type',
            activeSalesChannel: 'Active Sales Channel',
            dateLaunched: 'Date Launched',
            storeOwner: 'Store Owner',
            totalOrders: 'Total Orders',
            accumulatedConvenienceOrder: 'Accumulated Convenience Fee',
        };
        return labels;
    }
    get fields() {
        return Object.keys(this.labels);
    }
    get csvName() {
        const timestamp = moment().unix();
        return `${this.plan}_${timestamp}`;
    }
    alertError(merchants) {
        if (!merchants || merchants.length === 0) {
            this.errorNotification('No data to export');
        }
    }
};
__decorate([
    Getter('resellerUuid')
], ReferredMerchantExport.prototype, "resellerUuid", void 0);
ReferredMerchantExport = __decorate([
    Component({
        components: {
            ReferredMerchantsExport,
            BaseCsvExporter,
            ActionButton,
        },
    })
], ReferredMerchantExport);
export default ReferredMerchantExport;
